export enum EduTradingMarketVideoType {

    MarketResearch = "technicalAnalysis",
    MarketHighlight = "dailytv"
}
